import { useQuery } from '@tanstack/react-query';
import { getEffectivePermissions } from '@/api/auth';
import { useAuth } from './useAuth';

export function useEffectivePermissions() {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: ['effective-permissions'],
    queryFn: getEffectivePermissions,
    enabled: isAuthenticated,
    staleTime: Infinity,
  });
}
